import * as urls from 'constans/urls'
import Customers from 'pages/customers'
import {
  CreateGiftCondition,
  GiftConditionDetails,
  GiftConditionList,
  UpdateGiftCondition,
} from 'pages/gift-condition'
import Login from 'pages/login'
import Products from 'pages/products'
import {
  CreateRuleManagement,
  EditRuleManagement,
  RuleManagementDetails,
  RuleManagementList,
} from 'pages/rule-managements'

const routes = [
  {
    path: urls.RULE_MANAGEMENT_URLS.LIST,
    Element: RuleManagementList,
  },
  {
    path: urls.RULE_MANAGEMENT_URLS.CREATE,
    Element: CreateRuleManagement,
  },
  {
    path: urls.RULE_MANAGEMENT_URLS.DETAILS,
    Element: RuleManagementDetails,
  },
  {
    path: urls.RULE_MANAGEMENT_URLS.EDIT,
    Element: EditRuleManagement,
  },
  {
    path: urls.GIFT_CONDITION_URLS.LIST,
    Element: GiftConditionList,
  },
  {
    path: urls.GIFT_CONDITION_URLS.CREATE,
    Element: CreateGiftCondition,
  },
  {
    path: urls.GIFT_CONDITION_URLS.EDIT,
    Element: UpdateGiftCondition,
  },
  {
    path: urls.GIFT_CONDITION_URLS.DETAILS,
    Element: GiftConditionDetails,
  },
  {
    path: urls.CUSTOMER_URLS.List,
    Element: Customers,
  },
  {
    path: urls.PRODUCT_URLS.LIST,
    Element: Products,
  },
  {
    path: urls.ADMIN_URLS.LOGIN,
    Element: Login,
  },
]
export default routes
